import React from "react";
import { Business, Clients, CTA, Footer, Hero, UseCases, CardDeal, Carousel, SEO} from "../components";
import styles from "../style";

const homeStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Software India',
  url: 'https://www.softwareindia.com',
  description: 'Leading software development company in India offering web development, mobile apps, UI/UX design, video editing, branding, and enterprise solutions.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.softwareindia.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Software India',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.softwareindia.com/logo512.png',
    },
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="Software India | Leading Software Development Company in India | Web & Mobile Apps"
        description="Software India - Top-rated software development company in India. Expert web development, mobile apps, UI/UX design, video editing, branding, and enterprise solutions. Trusted by 230+ companies with guaranteed deadline completion."
        keywords="Software India, software development company India, web development services, mobile app development, UI/UX design, video editing services, branding services, enterprise software solutions, Indian IT company, custom software development, responsive web design, SEO services, domain management"
        url="https://www.softwareindia.com"
        canonical="https://www.softwareindia.com/"
        structuredData={homeStructuredData}
      />
    <div>
      <div className={`bg-[#00040F] ${styles.flexStart}`}>
        <div className={`${styles.boxWidth}`}>
        
          <Hero />
        </div>
      </div>
      <div className={`bg-[#00040F] ${styles.paddingX} ${styles.flexCenter}`}>
        <div className={`${styles.boxWidth}`}>
          {/* <Stats /> */}
          <Business />
          {/* <Billing /> */}
          <Carousel />
          {/* <Testimonials /> */}

          <CTA />
          <Clients />
          <UseCases />
          <CardDeal />
         
          <Footer />
        </div>
      </div>
    </div>
    </>
  );
}
